import {KTSVG} from '../../../_metronic/helpers'

const PasswordValidationUI = ({password, isTouched}: {password: string; isTouched: boolean}) => {
  const checks = [
    {label: '8+ characters minimum', valid: password.length >= 8},
    {label: 'one number', valid: /\d/.test(password)},
    {label: 'one uppercase character', valid: /[A-Z]/.test(password)},
    {label: 'one special character', valid: /[!@#$%^&*(),.?":{}|<>]/.test(password)},
    {label: 'one lowercase character', valid: /[a-z]/.test(password)},
  ]

  return (
    <ul className={`password-validation-list ${isTouched ? 'active' : 'inactive'}`}>
      {checks.map((check, index) => (
        <li key={index} className={password.length > 0 && check.valid ? 'valid' : 'inactive'}>
          <span className='circle'>
            {password.length > 0 && check.valid ? (
              <KTSVG path='/media/icons/duotune/general/right.svg' svgClassName='svg-icon-password-right-arrow' />
            ) : (
              <span className='empty-circle'></span>
            )}
          </span>
          <span
            className={
              isTouched
                ? password.length > 0
                  ? check.valid
                    ? 'valid'
                    : 'inactive'
                  : 'inactive'
                : 'inactive'
            }
          >
            {check.label}
          </span>
        </li>
      ))}
    </ul>
  )
}

export default PasswordValidationUI

export const checkPasswordValidity = (password: string) => {
  return (
    password.length >= 8 &&
    /\d/.test(password) &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[!@#$%^&*(),.?":{}|<>]/.test(password)
  )
}
